import { Transition } from '@headlessui/react';
import { ChevronDownMini } from '@medusajs/icons';
import { HttpTypes } from '@medusajs/types';
import { clx } from '@medusajs/ui';
import React, { useState } from 'react';

import { getCheckoutPrice } from '@lib/util/get-checkout-price';

interface CartCollapseContainerProps {
  cart: HttpTypes.StoreCart | null;
  children?: React.ReactNode;
}

const CartCollapseContainer = ({
  cart,
  children,
}: CartCollapseContainerProps) => {
  const { total: totalAmount } = getCheckoutPrice(cart);

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="border-white-40 bg-white-20 rounded-md border p-6 px-3 py-6 transition-all duration-1000 ease-in-out">
      <div className="flex flex-col items-center justify-center gap-2">
        <div className="flex items-center gap-4">
          <span>訂單金額</span>
          <span className="text-h2-bold whitespace-nowrap">{totalAmount}</span>
          <ChevronDownMini
            onClick={() => setIsExpanded(!isExpanded)}
            className={clx('mr-4 cursor-pointer duration-300 ease-in-out', {
              '-rotate-180': isExpanded,
            })}
          />
        </div>
        <div className="text-black-10">
          商品件數: {cart?.items?.length || 0}
        </div>
      </div>
      <Transition
        show={isExpanded}
        leave="transition ease-in-out duration-150"
        leaveFrom="opacity-100 backdrop-blur-2xl"
        leaveTo="opacity-0"
        as="div"
      >
        {children}
      </Transition>
    </div>
  );
};

export default CartCollapseContainer;
